import get from 'lodash/get'

export const selectCorporateSessionId = (state) =>
  get(state, 'corporate.last_session') !== get(state, 'corporate.id', '')
    ? get(state, 'corporate.id', '')
    : null
